import React from "react";
import { CheckCircle2, Circle } from "lucide-react";
import landing from "@/content/landing";
import { Section } from "./HeroSection";

/**
 * Rein statische, präsentative Vorschau des Lebensbaums.
 * Nutzt KEINE Auth/API/User-Daten — nur Demo-Werte aus landing.js.
 */
export default function LifeTreePreview() {
  const t = landing.lifeTree;
  return (
    <Section id="lebensbaum" className="bg-ag-paper relative overflow-hidden" data-testid="landing-lifetree">
      <div className="ag-gold-ambient" style={{ width: 460, height: 460, top: -220, right: -140, opacity: 0.2 }} aria-hidden="true" />
      <div className="grid gap-10 lg:grid-cols-12 lg:items-start lg:gap-16">
        <div className="lg:col-span-5">
          <div className="ag-overline mb-4">Der Lebensbaum</div>
          <h2 className="font-serif text-3xl leading-tight text-ag-ink sm:text-4xl lg:text-5xl">
            {t.headline}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-700 sm:text-[17px]">{t.text}</p>
          <div className="mt-6 flex items-center gap-4">
            <div className="h-px w-10 bg-amber-500/70" aria-hidden="true" />
            <p className="font-serif text-lg italic text-slate-500">{t.hint}</p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {t.demoAreas.map((area) => {
              const done = area.progress >= 60;
              const Icon = done ? CheckCircle2 : Circle;
              return (
                <div
                  key={area.name}
                  className="ag-premium-card flex items-center gap-4 p-4 sm:p-5"
                  data-testid={`landing-lifetree-area-${area.name.toLowerCase()}`}
                >
                  <Icon
                    className={`h-5 w-5 shrink-0 ${done ? "text-emerald-600" : "text-slate-400"}`}
                    strokeWidth={1.6}
                    aria-hidden="true"
                  />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-baseline justify-between gap-3">
                      <div className="font-serif text-base text-ag-ink">{area.name}</div>
                      <div className="text-xs font-medium text-slate-500">{area.progress}%</div>
                    </div>
                    <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-amber-400 to-amber-600"
                        style={{ width: `${area.progress}%` }}
                        aria-hidden="true"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <p className="mt-6 ag-overline">Beispielansicht · Ihre echten Werte entstehen mit Ihrem Konto</p>
        </div>
      </div>
    </Section>
  );
}
